import { EVENT_SETUP_SECTIONS } from './EVENT_SETUP_SECTIONS';

export const getRouterDirection = (oldPath: string, newPath: string) => {
  const oldGroups = /staff\/club\/[0-9]+\/event\/[0-9]+\/setup\/([a-z\-]+)/g.exec(oldPath);
  const oldPage = oldGroups && oldGroups.length > 1 ? oldGroups[1] : 'start';
  const newGroups = /staff\/club\/[0-9]+\/event\/[0-9]+\/setup\/([a-z\-]+)/g.exec(newPath);
  const newPage = newGroups && newGroups.length > 1 ? newGroups[1] : 'start';

  return EVENT_SETUP_SECTIONS[newPage as any] < EVENT_SETUP_SECTIONS[oldPage as any]
    ? 'reverse'
    : '';
};
